import { useState, useEffect } from "react";
import { saveDailyTimeCard, getAllProjects } from "../Api/DailyTimeCard";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const DailyTimeCard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [projects, setProjects] = useState([]);
  const [timeCardData, setTimeCardData] = useState({
    UserName: "",
    Date: "",
    ProjectCode: "",
    Hours: "",
    Tasks: "",
    Remarks: "",
    Location: "",
  });
  console.log(timeCardData);
  const dropdownOptions = {
    tasks: [
      { value: "ZPTC000001", label: "ZPTC000001 - Social media(L.I, I.G, FB) for STPL" },
      { value: "ZPTC000002", label: "ZPTC000002 - Social media(L.I, I.G, FB) for RPA" },
      { value: "ZPTC000003", label: "ZPTC000003 - Social media(L.I, I.G, FB) for MDM" },
      { value: "ZPTC000004", label: "ZPTC000004 - SEO for Saisatwik" },
      { value: "ZPTC000005", label: "ZPTC000005 - SEO for Rpaxpert" },
      { value: "ZPTC000006", label: "ZPTC000006 - SEO for MDMnexus" },
      { value: "ZPTC000007", label: "ZPTC000007 - Saisatwik Leaves" },
      { value: "ZPTC000008", label: "ZPTC000008 - Saisatwik Learning" },
      { value: "ZPTC000009", label: "ZPTC000009 - Project Management" },
      { value: "ZPTC000010", label: "ZPTC000010 - Profile Screening" },
      { value: "ZPTC000011", label: "ZPTC000011 - Profile Shortlisting" },
      { value: "ZPTC000012", label: "ZPTC000012 - Post Interview & Joining" },
      { value: "ZPTC000013", label: "ZPTC000013 - Marketing" },
      { value: "ZPTC000014", label: "ZPTC000014 - Business Development" },
      { value: "ZPTC000015", label: "ZPTC000015 - Requirement Gathering" },
      { value: "ZPTC000016", label: "ZPTC000016 - Development" },
      { value: "ZPTC000017", label: "ZPTC000017 - SIT" },
      { value: "ZPTC000018", label: "ZPTC000018 - Pre-Sales" },
      { value: "ZPTC000019", label: "ZPTC000019 - Accounting" },
      { value: "ZPTC000020", label: "ZPTC000020 - Zoho Books" },
      { value: "ZPTC000021", label: "ZPTC000021 - Banking" },
      { value: "ZPTC000022", label: "ZPTC000022 - SD Configuration" },
      { value: "ZPTC000023", label: "ZPTC000023 - Social Media- Br. K.S ch. Academy (Fb, Ig, Youtube)" },
      { value: "ZPTC000024", label: "ZPTC000024 - Website Designing - RPA" },
      { value: "ZPTC000025", label: "ZPTC000025 - Website Designing - MDM" },
      { value: "ZPTC000026", label: "ZPTC000026 - Website Designing - STPL" },
      { value: "ZPTC000027", label: "ZPTC000027 - Website Designing - Mavro" },
      { value: "ZPTC000028", label: "ZPTC000028 - Social Media (LI, IG, FB) for Bizflo" },
      { value: "ZPTC000029", label: "ZPTC000029 - Social Media (LI, IG, FB) for Mavro" },
    ],
    locations: [
      { value: "01", label: "01 - Work from Home" },
      { value: "02", label: "02 - Work from Office" },
      { value: "03", label: "03 - Work from Client" }
    ]
  };
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch user data
        const username = localStorage.getItem("username");
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        
        if (!username) {
          toast.error("User session expired. Please login again.");
          navigate("/");
          return;
        }

        // Fetch projects
        const projectsData = await getAllProjects();
        console.log(projectsData);
        setProjects(projectsData);

        // Set initial form data
        setTimeCardData(prev => ({
          ...prev,
          UserName: username,
          Date: new Date().toISOString().split('T')[0]
        }));
        
      } catch (error) {
        console.error("Error loading data:", error);
        toast.error("Failed to load data");
      } finally {
        setInitialLoad(false);
      }
    };

    fetchData();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTimeCardData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (timeCardData.Hours <= 0 || timeCardData.Hours > 24) {
      toast.error("Please enter valid hours (0-24)");
      return;
    }

    setLoading(true);
    try {
      await saveDailyTimeCard(timeCardData, timeCardData.UserName);
      toast.success("Daily Time Card submitted successfully!");
      
      // Reset form except UserName and Date
      setTimeCardData(prev => ({
        ...prev,
        ProjectCode: "",
        Hours: "",
        Tasks: "",
        Remarks: "",
        Location: ""
      }));
      
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "Failed to submit time card");
    } finally {
      setLoading(false);
    }
  };

  if (initialLoad) {
    return (
      
        <div className="main-content expand">
          <Container fluid className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <Sample14 />
          </Container>
        </div>
      
    );
  }

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Daily Time Card</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>User Name <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="UserName"
                      value={timeCardData.UserName}
                      readOnly
                      className="read-only-field bg-light"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Date <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="date"
                      name="Date"
                      value={timeCardData.Date}
                      onChange={handleChange}
                      required
                      max={new Date().toISOString().split('T')[0]} 
                    />
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Project Code <span className="text-danger">**</span></Form.Label>
                    <Form.Select
                      name="ProjectCode"
                      value={timeCardData.ProjectCode}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Project</option>
                      {projects.map(project => (
                        <option key={project.projectId} value={project.projectId}>
                          {project.projectId} - {project.prTitle}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Task <span className="text-danger">**</span></Form.Label>
                    <Form.Select
                      name="Tasks"
                      value={timeCardData.Tasks}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Task</option>
                      {dropdownOptions.tasks.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Hours <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="number"
                      name="Hours"
                      value={timeCardData.Hours}
                      onChange={handleChange}
                      required
                      step="1"
                      min="1"
                      max="24"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={1}
                      name="Remarks"
                      value={timeCardData.Remarks}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Location <span className="text-danger">**</span></Form.Label>
                    <Form.Select
                      name="Location"
                      value={timeCardData.Location}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Location</option>
                      {dropdownOptions.locations.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container mt-4">
                <Button 
                  variant="primary" 
                  type="submit" 
                  className="fields-submit"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit Time Card"}
                </Button>
              </div>
            </Form>
          </Container>
        </div>
    

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default DailyTimeCard;